import { Tree, Checkbox } from "antd";
import React, { useState, useEffect } from "react";
import "../../styles/compareWizard.css";
import StepFooter from "./StepFooter";

const getAllKeys = (data) => {
  let keys = [];
  data.forEach((item) => {
    keys.push(item.key);
    if (item.children) {
      keys = keys.concat(getAllKeys(item.children));
    }
  });
  return keys;
};
const extractTitlesByKeys = (tree, checkedKeys) => {
  let titles = [];
  tree.forEach((node) => {
    if (checkedKeys.includes(node.key)) {
      titles.push(node.title); // Add current node's title if checked
    }
    if (node.children) {
      titles = titles.concat(extractTitlesByKeys(node.children, checkedKeys)); // Recursively add children's titles
    }
  });
  return titles;
};
const disableNodesByTitle = (tree, disabledTitles) => {
  return tree.map((node) => {
    if (disabledTitles.includes(node.title)) {
      return { ...node, disabled: true };
    }
    if (node.children) {
      return {
        ...node,
        children: disableNodesByTitle(node.children, disabledTitles),
      };
    }
    return node;
  });
};

function SelectTest(props) {
  let selectedColumns = props.mappingDataSource.map((item) => item["source1"]);
  const disabledTitles = [
    "No duplicate Row Keys in the First Data Source",
    "No duplicate Row Keys in the Second Data Source",
  ];
  const [checkedRowTest, setCheckedRowTest] = useState([]);
  const [modifiedRow, setModifiedRow] = useState([]);
  const [checkedFieldTest, setCheckedFieldTest] = useState(
    getAllKeys(props.fieldLevelTests)
  );
  useEffect(() => {
    const updatedTreeData = disableNodesByTitle(
      props.rowLevelTests,
      disabledTitles
    );
    const allKeys = getAllKeys(updatedTreeData);
    setCheckedRowTest(allKeys);
    setModifiedRow(updatedTreeData);
    setRowTests(extractTitlesByKeys(props.rowLevelTests, allKeys));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.rowLevelTests]);
  const [checkSaveMapping, setCheckSaveMapping] = useState(false);
  const [rowTests, setRowTests] = useState([]);
  const [fieldTests, setFieldTests] = useState(selectedColumns);
  const onChangeRowTest = (checkedKeysValue, info) => {
    const titles = info.checkedNodes.map((node) => node.title);
    setCheckedRowTest(checkedKeysValue);
    setRowTests(titles);
  };
  const onChangeFieldTest = (checkedKeysValue, info) => {
    const titles = info.checkedNodes.map((node) => node.title);
    console.log("Checked Titles:", titles);
    setCheckedFieldTest(checkedKeysValue);
    setFieldTests(titles);
  };

  const onClickPrevious = () => {
    props.clickPrevious(3);
  };
  const onClickRun = () => {
    props.clickRun(checkSaveMapping, rowTests, fieldTests);
  };

  return (
    <div className="cmp-pane">
      <p style={{ color: "var(--arc-table)", fontSize: 13, marginBottom: 12 }}>
        The following tests are generated by default. Select the ones to run.
      </p>

      <div className="cmp-block">
        <span className="cmp-field-label">Row-level tests</span>
        <Tree
          checkable
          treeData={modifiedRow}
          onCheck={onChangeRowTest}
          checkedKeys={checkedRowTest}
        />
      </div>

      <div className="cmp-block">
        <span className="cmp-field-label">Field-level tests</span>
        <Tree
          checkable
          treeData={props.fieldLevelTests}
          onCheck={onChangeFieldTest}
          checkedKeys={checkedFieldTest}
        />
      </div>

      <div style={{ padding: "10px 0" }}>
        <Checkbox
          value={checkSaveMapping}
          onChange={() => setCheckSaveMapping(!checkSaveMapping)}
        >
          Save mapping for future use
        </Checkbox>
      </div>

      <StepFooter
        showBack
        onBack={onClickPrevious}
        onNext={onClickRun}
        nextLabel="Run"
      />
    </div>
  );
}

export default SelectTest;
